import React from "react";
import { Helmet } from "react-helmet";
import mediaQuery from "~utils/mediaQuery.js";

const SANS_FALLBACKS = `"Helvetica Neue", "Helvetica", ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"`;
const PP_NEUE_MONTREAL_ID = `PP Neue Montreal`;
const PP_NEUE_MONTREAL_TEXT_GROUP = `"${PP_NEUE_MONTREAL_ID}", ${SANS_FALLBACKS}`;

const Fonts = () => {
  const fontCss = `
		@font-face {
			font-family: "${PP_NEUE_MONTREAL_ID}";
			src: url(/fonts/pp-neue-montreal-bold.woff2) format("woff2"), url(/fonts/pp-neue-montreal-bold.woff) format("woff");
			font-display: block;
			font-weight: 900;
			font-style: normal;
		}

		@font-face {
			font-family: "${PP_NEUE_MONTREAL_ID}";
			src: url(/fonts/pp-neue-montreal-medium.woff2) format("woff2"),
				url(/fonts/pp-neue-montreal-medium.woff) format("woff");
			font-display: block;
			font-weight: normal;
			font-style: normal;
		}

		div,
		.d1,
		.h1,
		.h2,
		.h3,
		.h4,
		.h5,
		.h6,
		.b1,
		.b2,
		.button-text,
		.caption {
			font-family: ${PP_NEUE_MONTREAL_TEXT_GROUP};
			font-weight: normal;
		}

		.d1 {
			font-weight: 700;
			font-size: 48px;
			line-height: 110%;
			letter-spacing: -0.0125em;
			text-transform: uppercase;
		}

		.d2 {
			font-weight: 700;
			font-size: 36px;
			line-height: 110%;
			letter-spacing: -0.0125em;
			text-transform: uppercase;
		}

		.h1 {
			font-weight: 700;
			font-size: 28px;
			line-height: 110%;
			letter-spacing: -0.005em;
			text-transform: uppercase;
		}

		.h2 {
			font-weight: 700;
			font-size: 24px;
			line-height: 110%;
			letter-spacing: -0.005em;
			text-transform: uppercase;
		}

		.h3 {
			font-weight: 700;
			font-size: 20px;
			line-height: 110%;
			letter-spacing: -0.005em;
			text-transform: uppercase;
		}

		.h4 {
			font-weight: 700;
			font-size: 18px;
			line-height: 110%;
			letter-spacing: -0.005em;
			text-transform: uppercase;
		}

		.b1 {
			font-weight: 500;
			font-size: 18px;
			line-height: 110%;
			letter-spacing: 0.004em;
		}

		.b2 {
			font-weight: 500;
			font-size: 14px;
			line-height: 110%;
			letter-spacing: 0.01em;
		}

		.caption {
			font-weight: 500;
			font-size: 12px;
			line-height: 110%;
			letter-spacing: 0.02em;
		}

		.button-text {
			font-weight: 700;
			font-size: 16px;
			line-height: 120%;
			letter-spacing: 0.01em;
			text-transform: uppercase;
		}

		${mediaQuery(`smallTablet`)} {
			.d1 {
				font-size: 80px;
				line-height: 90%;
				letter-spacing: -0.02em;
			}

			.d2 {
				font-size: 62px;
				line-height: 90%;
				letter-spacing: -0.02em;
			}

			.h1 {
				font-size: 48px;
				line-height: 110%;
				letter-spacing: -0.02em;
			}

			.h2 {
				font-size: 35px;
				line-height: 110%;
				letter-spacing: -0.02em;
			}

			.h3 {
				font-size: 24px;
				line-height: 110%;
				letter-spacing: -0.02em;
			}

			.h4 {
				font-size: 20px;
				line-height: 110%;
				letter-spacing: -0.02em;
			}

			.b1 {
				font-size: 20px;
				line-height: 110%;
				letter-spacing: 0.01em;
			}

			.b2 {
				font-size: 16px;
				line-height: 110%;
				letter-spacing: 0.01em;
			}

			.caption {
				font-size: 12px;
				line-height: 120%;
				letter-spacing: 0.02em;
			}
		}
	`;

  return (
    <Helmet>
      <style>{fontCss}</style>
    </Helmet>
  );
};

export default Fonts;
